var React = require('react');

function Divider1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,0 C40,33 66,52 75,52 C83,52 92,33 100,0 L100,100 L0,100 L0,0 Z"}));
}

Divider1.defaultProps = {"width":"100%","height":"96px","viewBox":"0 0 100 100","version":"1.1","preserveAspectRatio":"none"};

module.exports = Divider1;

Divider1.default = Divider1;
